import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
export function WishlistSection() {
  const [wishlistItems, setWishlistItems] = useState([{
    id: 1,
    name: 'Panadol Extra Pain Relief Tablets 24s',
    price: 12.99,
    originalPrice: 15.99,
    discount: 19,
    brand: 'Panadol',
    rating: 4.5,
    reviewCount: 124,
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop'
  }, {
    id: 2,
    name: 'Vitamin D3 1000 IU Supplement 60 Capsules',
    price: 24.99,
    brand: 'Nature Made',
    rating: 4.8,
    reviewCount: 89,
    image: 'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop'
  }, {
    id: 3,
    name: 'Digital Blood Pressure Monitor',
    price: 89.99,
    brand: 'Omron',
    rating: 4.7,
    reviewCount: 56,
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400&h=400&fit=crop'
  }, {
    id: 4,
    name: 'First Aid Emergency Kit',
    price: 45.99,
    originalPrice: 58.99,
    discount: 22,
    brand: 'Johnson & Johnson',
    rating: 4.6,
    reviewCount: 42,
    image: 'https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400&h=400&fit=crop'
  }]);
  return <div className="space-y-6" data-id="element-1107" data-mp="2nnfujnpb8qey">
      <div className="flex items-center justify-between" data-id="element-1108" data-mp="2nm4oticb18l7">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-1109" data-mp="2sl7i65ix9qdc">
          My Wishlist ({wishlistItems.length})
        </h2>
        {wishlistItems.length > 0 && <button className="text-sm font-medium text-red-600 hover:underline" data-id="element-1110" data-mp="2xek6eejovv5k">
            Clear All
          </button>}
      </div>
      {wishlistItems.length === 0 ? <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-12 text-center" data-id="element-1111" data-mp="36eqf7n4g06ye">
          <HeartIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-1112" data-mp="3bcrya81vc69v" />
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1113" data-mp="1b97jqidnyryr">
            Your wishlist is empty
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-1114" data-mp="179p0dr1hqoy1">
            Start adding items you love to your wishlist
          </p>
          <a href="/" className="inline-block px-6 py-3 bg-[#1E2B55] text-white font-medium rounded-lg hover:bg-[#162041] transition-colors" data-id="element-1115" data-mp="1l13lq4ivf289">
            Continue Shopping
          </a>
        </div> : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-1116" data-mp="1pz5czcqga7ut">
          {wishlistItems.map(item => <EnhancedProductCard key={item.id} product={item} data-id="element-1117" data-mp="23xlkv701u4ej" />)}
        </div>}
    </div>;
}